import { AuthContext } from "../contexts/authContext";
import { useContext } from "react";

export function useActiveUserRoles() {
  const authContext = useContext(AuthContext);
  const isSolutionOperator =
    authContext.currentUser?.accessToken?.hasRole("solution-operator") ?? false;

  const isRoadSafetyManager =
    authContext.currentUser?.accessToken?.hasRole("road-safety-manager") ??
    false;

  const isSCBOneDataAnalyst =
    authContext.currentUser?.accessToken?.hasRole("scb-one-data-analyst") ??
    false;

  const isUserAdministrator =
    authContext.currentUser?.accessToken?.hasRole("user-administrator") ??
    false;

  const isIntegrationPlatformUser =
    authContext.currentUser?.accessToken?.hasRole(
      "integration-platform-user"
    ) ?? false;

  const roles =
    authContext.currentUser?.accessToken?.payload["cognito:groups"] ?? [];

  return {
    isSolutionOperator,
    isRoadSafetyManager,
    isSCBOneDataAnalyst,
    isUserAdministrator,
    isIntegrationPlatformUser,
    roles,
  };
}
